<template>
  <div id="adminSettinManageStyle">
    <ol class="breadcrumb" style="margin-bottom: 0rem;">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ manageStyle }}</router-link>
      </li>
         <li style="float: right; position: absolute; right: 15px; font-weight: bold; font-size: 20px; color: rgb(48, 60, 84); text-transform: uppercase; margin-top: -5px;">
         <button type="button" style="color:#fff;" class="btn btn-warning" @click="compareTemplateCssEmailAndCss">Affianca</button>
      <!-- <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelDataGlobal"
                        >{{ cancel }}</button> --->
                        <button type="button" class="btn btn-success" @click="confirmSaveDataGlobal"><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
      </li>                   
    </ol>                      
    <div class="container" style="max-width:100%!important;max-height:100%!important;">
    <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
    <div class="row">
              <div class="col-sm-12">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <button
                      id="tabCss"
                      class="nav-links active"
                      type="button"
                      data-toggle="tab"
                      href="#tabCss"
                      role="tab"
                      aria-controls="tabCss"
                      v-on:click="ontabCss"
                    >
                      <span>Css Web Head</span>
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      id="tabCssHead"
                      class="nav-links"
                      type="button"
                      data-toggle="tab"
                      href="#tabCssHead"
                      role="tab"
                      aria-controls="tabCssHead"
                      v-on:click="ontabCssHead"
                    >
                      <span>Css Web Body</span>
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      id="tabCssEmail"
                      class="nav-links"
                      type="button"
                      data-toggle="tab"
                      href="#tabCssEmail"
                      role="tab"
                      aria-controls="tabCssEmail"
                      v-on:click="ontabCssEmail"
                    >
                      <span>Css Email</span>
                    </button>
                  </li>
                </ul>

              <div class="tab-content">
                <!-- CSS -->
                <div class="card-body active tab-pane" id="css">
                <div class="container" style="max-width:100%!important;max-height:100%!important;">    
                    <div class="row">
                      <div class="col">
                    <codemirror v-model="cssToSave"
                        ref="myCm"
                        :value="code"
                        @ready="onCmReady"
                        @focus="onCmFocus"
                        @input="onCmCodeChange"
                    :options="cmOptions"
                   ></codemirror>

                        <!-- <codemirror v-model="cssToSave" :options="cmOptions"></codemirror>--->
                      </div>
                    </div>
                    <div class="row">&nbsp;</div>
                    <div class="row">
                      <div class="col-12 text-right">
                      <!--<button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelData"
                        >{{ cancel }}</button> ----->
                        <button type="button" class="btn btn-success" @click="confirmSaveData"><i class="fa fa-floppy-o"></i>&nbsp; Salva Css Head</button>
                      </div>
                    </div>
                  </div>
                </div>
            <!--END CSS -->

            <!-- CSS Head-->
                <div class="card-body tab-pane" id="cssHead">
                <div class="container" style="max-width:100%!important;max-height:100%!important;">  
                   
                    <div class="row">
                      <div class="col">
                        <codemirror v-model="cssToSaveHead" :options="cmOptions"></codemirror>

                      </div>
                    </div>
                    <div class="row">&nbsp;</div>
                    <div class="row">
                      <div class="col-12 text-right">
                        <button type="button" class="btn btn-success" @click="confirmSaveDataHead"><i class="fa fa-floppy-o"></i>&nbsp; Salva Css Body</button>
                      </div>
                    </div>
                  </div>
                </div>
            <!--END CSS Head-->
 
              <!-- CSS Email -->
              <div class="card-body tab-pane" id="cssEmail">
                <div class="container" style="max-width:100%!important;max-height:100%!important;">
                    <div class="row">
                      <div class="col">
                        <codemirror v-model="cssToSaveEmail" :options="cmOptions"></codemirror>
                      </div>
                    </div>
                    <div class="row">&nbsp;</div>
                    <div class="row">
                      <div class="col-12 text-right">
                        <!--<button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelDataEmail"
                        >{{ cancel }}</button>--->
                        <button type="button" class="btn btn-success" @click="confirmSaveDataEmail"><i class="fa fa-floppy-o"></i>&nbsp; Salva Css Email</button>
                      </div>
                    </div>
                  </div>
                </div>
            <!--END CSS Email --></div>
  </div></div>
  </div></div>
<!--TemplateCssEmailAndCss -->
<div class="tab-content"> 
      <div class="card-body tab-pane" id="TemplateCssEmailAndCss">
                      <div class="container" style="max-width:100%!important;max-height:100%!important;">
                          <div class="row">
                            <div class="col-6">
                              <codemirror v-model="cssToSave" :options="cmOptions"></codemirror>
                            </div>
                            <div class="col-6">
                              <codemirror v-model="cssToSaveEmail" :options="cmOptions"></codemirror>
                            </div>
                          </div>
                          <div class="row">&nbsp;</div>
                          <div class="row">
                            <div class="col-12 text-right">
                            <!-- <button
                                type="button"
                                class="btn btn-danger"
                                data-dismiss="modal"
                                @click="confirmCancelDataGlobal"
                              >{{ cancel }}</button>-->
                              <button type="button" class="btn btn-success" @click="confirmSaveDataGlobal"><i class="fa fa-floppy-o"></i>&nbsp; {{ save }}</button>
                            </div>
                          </div>
                        </div>
                      </div>
      </div> 
<!--End TemplateCssEmailAndCss -->
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";
  
// theme css
import 'codemirror/theme/paraiso-light.css';

import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/lib/codemirror';
import 'codemirror/mode/sql/sql';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/search/searchcursor';
import 'codemirror/addon/search/search';
import 'codemirror/addon/display/placeholder';
import 'codemirror/addon/hint/sql-hint';
import 'codemirror/addon/hint/anyword-hint';

// require active-line.js
import 'codemirror/addon/selection/active-line.js';

import  "codemirror/addon/hint/show-hint.js" ;
import 'codemirror/mode/javascript/javascript.js'

import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/lib/codemirror.js';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/xml-fold.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/fold/markdown-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/xml/xml.js';

import 'codemirror/mode/htmlmixed/htmlmixed.js';
import 'codemirror/mode/python/python.js';
import 'codemirror/mode/markdown/markdown.js';

import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/match-highlighter.js'
import 'codemirror/addon/search/jump-to-line.js'

import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'

import 'codemirror/lib/codemirror.css'
//import 'codemirror/addon/lint/lint.css'
import 'codemirror/mode/css/css.js'
//import 'codemirror/addon/lint/lint.js'
//import 'codemirror/addon/lint/javascript-lint.js'
//import 'codemirror/addon/lint/json-lint.js'
//import 'codemirror/addon/lint/css-lint.js' 

export default {
  name: "adminSettinManageStyle",
  components: {
    codemirror
  },
  data() {
    return {
      code:0,
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      confirmCancel: dictionaryHelpers.getDictionary("ConfirmCancel"),
      confirmSave: dictionaryHelpers.getDictionary("ConfirmSave"),
       cmOptions: {
        lineNumbers: true,
        mode: "css",
        //gutters: ["CodeMirror-lint-markers"],
        lint: true,
        indentWithTabs: true,
        lineNumbers: true,
        line: true,
        indentUnit: 4,
        autofocus: true,
        styleActiveLine: true,
        matchBrackets: true,
      //  mode: "text/css",
        lineWrapping: true,
        addModeClass:true,
        theme: 'default',
        tabMode: "indent",
        tabSize: 4,
        extraKeys: {
          Ctrl: 'autocomplete',
        },
        extraKeys: {"Ctrl-Q": function(cm){ cm.foldCode(cm.getCursor()); }},
          gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        foldGutter: true,
        },
         hintOptions:{
          completeSingle: true
        },
      /*cmOptions: {
        indentWithTabs: true,
        line: true,
        lineNumbers: true,
        styleActiveLine: true,
        lineWrapping: true,
        mode: "text/css",
        theme: 'paraiso-light',
        extraKeys: {'Ctrl-Space': 'autocomplete'},
        tabMode: "indent",
        tabSize: 4
      },*/
      cssToSave: "",
      cssToSaveEmail: "",
      cssToSaveHead: "",
      manageStyle: dictionaryHelpers.getDictionary("ManageStyle"),
      save: dictionaryHelpers.getDictionary("Save"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname
    };
  },
 

  created() {
    spinnerHelpers.show();
    this.loadCss();

    setTimeout(function() {
      var height =
        window.innerHeight -
        150 -
        $(".app-header").height() -
        $(".breadcrumb").height() -
        $(".app-footer").height();

      $(".vue-codemirror").height(height);
      $(".CodeMirror").height(height);
      $(".CodeMirror-gutters").css('z-index', '2');
      $(".CodeMirror-gutter-wrapper").css('z-index', '3');
    }, 100);
  },

  computed: {
    codemirror() {
        return this.$refs.myCm.codemirror;
    },
  },


  methods: {
    loadCss() {
      var adminSettinManageStyle = this;
      manageStyleServices.get(function(result) {
        adminSettinManageStyle.cssToSave = result.message;
        spinnerHelpers.hide();
      $("#css").addClass("active");
      $("#cssEmail").removeClass("active");
      $("#TemplateCssEmailAndCss").removeClass("active");
      });
    },

    	searchCode (e) {
      this.codemirror.execCommand('find') // Trigger 
    },


onCmReady(cm) {
    cm.on('keypress', () => {
        cm.showHint({completeSingle:false})
    })
},

    onCmFocus() {
    },

    onCmCodeChange(newCode) {
      this.code = newCode;
    },

    onChange() {
      this.codemirror.showHint();
    },


/*  onCmReady(cm) {
      console.log('the editor is readied!', cm)
    },
    onCmFocus(cm) {
      console.log('the editor is focused!', cm)
    },
    onCmCodeChange(newCode) {
      console.log('this is new code', newCode)
      this.code = newCode
    },
*/

    confirmCancelData() {
      if (confirm(this.confirmCancel)) {
        this.executeCancelData();  
      }
    },
    executeCancelData() {
      spinnerHelpers.show();
     // this.cssToSave = this.cssRead;
      notificationHelpers.error('Annullamento eseguito con successo');
      spinnerHelpers.hide();
    },

    confirmSaveData() {
      if (confirm(this.confirmSave)) {
        this.executeSaveData();
      }
    },

    confirmSaveDataHead() {
      if (confirm(this.confirmSave)) {
        this.executeSaveDataHead();
      }
    },
    executeSaveDataHead() {
    spinnerHelpers.show();
    var adminSettinManageStyle = this;

    var data = {
     cssToSave:this.cssToSaveHead
    };
    manageStyleServices.updateSaveHead(data, function() {
    notificationHelpers.success(adminSettinManageStyle.updateCompleted);
     spinnerHelpers.hide();
      
    });
  },

    executeSaveData() {
      spinnerHelpers.show();
      var adminSettinManageStyle = this;
      manageStyleServices.update(this.cssToSave, function() {
        notificationHelpers.success(adminSettinManageStyle.updateCompleted);
        adminSettinManageStyle.loadCss();
      $("#css").addClass("active");
      $("#cssEmail").removeClass("active");
      $("#TemplateCssEmailAndCss").removeClass("active");
      });
    },
    //end section css 

    //global save date
     confirmSaveDataGlobal() {
      if (confirm(this.confirmSave)) {
        this.executeSaveDataGlobal();
      }
    },

  executeSaveDataGlobal() {
    spinnerHelpers.show();
    var adminSettinManageStyle = this;

    var data = {
     cssToSave:this.cssToSave,
     cssToSaveEmail: this.cssToSaveEmail,
    };
    manageStyleServices.updateSaveGlobal(data, function() {
    notificationHelpers.success(adminSettinManageStyle.updateCompleted);
     spinnerHelpers.hide();
      
    });
  },

    confirmCancelDataGlobal() {
          if (confirm(this.confirmCancel)) {
            this.executeCancelGlobal();  
          }
        },
    executeCancelGlobal() {
      spinnerHelpers.show();
     // this.cssToSave = this.cssRead;
      notificationHelpers.error('Annullamento eseguito con successo');
      spinnerHelpers.hide();
    },
  

    // end global save date
    ontabCss: function () {     
      $("#css").addClass("active");
      $("#cssEmail").removeClass("active");
      $("#cssHead").removeClass("active");
      $("#TemplateCssEmailAndCss").removeClass("active");
    },
    ontabCssEmail: function () {
        var adminSettinManageStyle = this;
        manageStyleServices.getCssEmail(function(result) {
          adminSettinManageStyle.cssToSaveEmail = result.message;
          spinnerHelpers.hide();
          $("#cssEmail").addClass("active");

        $("#cssHead").removeClass("active");
          $("#css").removeClass("active");
          $("#TemplateCssEmailAndCss").removeClass("active");
        });
    },

     ontabCssHead: function () {
        var adminSettinManageStyle = this;
        manageStyleServices.getCssHead(function(result) {
          adminSettinManageStyle.cssToSaveHead = result.message;
          spinnerHelpers.hide();
          $("#cssEmail").removeClass("active");

          $("#cssHead").addClass("active");
          $("#css").removeClass("active");
          $("#TemplateCssEmailAndCss").removeClass("active");
        });
    },

  //section css email
    confirmCancelDataEmail() {
      if (confirm(this.confirmCancel)) {
        this.executeCancelDataEmail();  
      }
    },
    executeCancelDataEmail() {
          spinnerHelpers.show();
          //this.cssToSaveEmail = this.cssRead;
          notificationHelpers.error('Annullamento eseguito con successo');
          spinnerHelpers.hide();
        },    

    confirmSaveDataEmail() {
      if (confirm(this.confirmSave)) {
        this.executeSaveDataEmail();
      }
    },
    executeSaveDataEmail() {
      spinnerHelpers.show();
      var adminSettinManageStyle = this;

      manageStyleServices.updateCssEmail(this.cssToSaveEmail, function() {
        notificationHelpers.success(adminSettinManageStyle.updateCompleted);
        adminSettinManageStyle.ontabCssEmail();
      $("#cssEmail").addClass("active");
      $("#css").removeClass("active");
      $("#TemplateCssEmailAndCss").removeClass("active");
      });
    },

    // end section css email

  //Compare
      compareTemplateCssEmailAndCss() {
      var adminSettinManageStyle = this;

      manageStyleServices.get(function(result) {
          adminSettinManageStyle.cssToSave = result.message;
      });

        manageStyleServices.getCssEmail(function(result) {
          adminSettinManageStyle.cssToSaveEmail = result.message;
        });
        
          $("#TemplateCssEmailAndCss").addClass("active");
          $("#cssEmail").removeClass("active");
          $("#css").removeClass("active");
    },
  // End Compare
  },
};
</script>

<style>

.tab-content .tab-pane {
    padding: 0rem;
}
.col-12, .col, .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl, .col-xl-auto {
    position: relative;
    width: 100%;
    padding-right: 0px;
    padding-left: 0px;
}

#tabDetail .nav-item{
  width:33.33% !important;
}
.nav-tabs .nav-links {
    width: 100%;
    border-radius: 0;
    color: #fff;
    background: #73818f;
    border-bottom: 3px solid #936c6c !important;
    border: 0px;
    height: 40px;
}

.nav-tabs .nav-links.active {
  background-color:#936c6c;
}

#adminSettinJS .CodeMirror-gutters, #adminSettinManageStyle .CodeMirror-gutters{
  z-index:2 !important;
}
#adminSettinJS  .CodeMirror-gutter-wrapper, #adminSettinManageStyle .CodeMirror-gutter-wrapper{
  z-index:3 !important;
}

</style>

